import React from 'react';
import { observer } from "mobx-react";
import { AnyQuestions } from "../../components/block/AnyQuestions";
import { withStore } from "../../hocs";
import ReactGA from "react-ga";
import { YOUR_TRACKING_ID } from "../../stores/AppStore";
import { Button, Paper, Box, Grid, Typography, Alert } from "@mui/material";
import ContentModel from "../../model/ContentModel";
import Dropzone from "react-dropzone";
import { ADMIN_ROUTE_PATHS } from "../../constants/adminRoutes";

// @ts-ignore
@withStore
@observer
export default class AdminTelegramBanners extends React.Component {
    state = {
        banners: [] as string[],
        loading: false,
        error: null as string | null,
        success: null as string | null,
        uploading: false,
    };

    setGA = () => {
        ReactGA.initialize(YOUR_TRACKING_ID);
        ReactGA.pageview(window.location.pathname + window.location.search);
    };

    componentDidMount() {
        this.loadBanners();
        this.setGA();
    }

    extractFileName = (urlOrName: string): string => {
        // Если это URL, извлекаем имя файла
        if (urlOrName.includes('/')) {
            return urlOrName.split('/').pop() || urlOrName;
        }
        // Если это уже имя файла, возвращаем как есть
        return urlOrName;
    };

    loadBanners = () => {
        this.setState({ loading: true, error: null });
        ContentModel.getTelegramBanners(
            (response: any) => {
                let banners: string[] = [];
                const data = response?.data || response;
                
                console.log('Banners API response:', data);
                
                if (Array.isArray(data)) {
                    // Сохраняем исходные данные (URL или имя файла)
                    banners = data;
                } else if (data && typeof data === 'object') {
                    // Если объект с массивом или другим форматом
                    banners = Array.isArray(data.files) ? data.files : 
                             Array.isArray(data.banners) ? data.banners : [];
                }
                
                console.log('Processed banners:', banners);
                this.setState({ banners, loading: false });
            },
            (error: any) => {
                console.error('Error loading banners:', error);
                this.setState({ 
                    error: 'Ошибка при загрузке баннеров', 
                    loading: false 
                });
            }
        );
    };

    handleFileUpload = (files: File[]) => {
        if (files.length === 0) return;

        const file = files[0];
        const formData = new FormData();
        formData.append('file', file);

        this.setState({ uploading: true, error: null, success: null });

        ContentModel.uploadTelegramBanner(
            formData,
            (response: any) => {
                this.setState({ 
                    uploading: false, 
                    success: 'Баннер успешно загружен' 
                });
                this.loadBanners();
                setTimeout(() => this.setState({ success: null }), 3000);
            },
            (error: any) => {
                console.error('Error uploading banner:', error);
                this.setState({ 
                    uploading: false, 
                    error: 'Ошибка при загрузке баннера' 
                });
            }
        );
    };

    handleDelete = (fileName: string) => {
        // Извлекаем только имя файла из URL, если это необходимо
        const cleanFileName = this.extractFileName(fileName);
        
        if (!window.confirm(`Вы уверены, что хотите удалить баннер "${cleanFileName}"?`)) {
            return;
        }

        ContentModel.deleteTelegramBanner(
            cleanFileName,
            (response: any) => {
                this.setState({ success: 'Баннер успешно удален' });
                this.loadBanners();
                setTimeout(() => this.setState({ success: null }), 3000);
            },
            (error: any) => {
                console.error('Error deleting banner:', error);
                this.setState({ error: 'Ошибка при удалении баннера' });
            }
        );
    };

    getImageUrl = (urlOrFileName: string) => {
        if (!urlOrFileName) return '';
        
        // Убираем пробелы в начале и конце
        const cleanUrl = urlOrFileName.trim();
        
        // Если это уже полный URL, используем его как есть
        if (cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://')) {
            return cleanUrl;
        }
        
        // Если это путь без протокола, но с доменом (начинается с //)
        if (cleanUrl.startsWith('//')) {
            return `https:${cleanUrl}`;
        }
        
        // Если содержит домен, но без протокола - добавляем https://
        if (cleanUrl.includes('img.sellwingroup.com') || cleanUrl.includes('sellwingroup.com')) {
            // Убираем протокол, если он есть, и добавляем https://
            const urlWithoutProtocol = cleanUrl.replace(/^https?:\/\//, '');
            return `https://${urlWithoutProtocol}`;
        }
        
        // Иначе строим URL из имени файла через бэкенд
        ContentModel.q.setBaseUrl();
        const fileName = encodeURIComponent(cleanUrl);
        return `${ContentModel.q.baseURL}/content/telegram-banners/${fileName}`;
    };

    render() {
        const { banners, loading, error, success, uploading } = this.state;

        return (
            <>
                <main className="page__main">
                    <div className="container">
                        <ul className="breadcrumbs">
                            <li className="breadcrumbs__item">
                                <a className="breadcrumbs__link" href="/">Главная</a>
                            </li>
                            <li className="breadcrumbs__item">
                                <a className="breadcrumbs__link" href={ADMIN_ROUTE_PATHS.base}>Администрирование</a>
                            </li>
                            <li className="breadcrumbs__item">Управление Telegram баннерами</li>
                        </ul>
                    </div>

                    <div style={{ padding: 20 }}>
                        <h2 style={{ fontSize: 18, fontWeight: "bold" }}>
                            Управление Telegram баннерами
                        </h2>
                    </div>

                    {error && (
                        <Box style={{ width: "95%", margin: "auto", marginBottom: 20 }}>
                            <Alert severity="error" onClose={() => this.setState({ error: null })}>
                                {error}
                            </Alert>
                        </Box>
                    )}

                    {success && (
                        <Box style={{ width: "95%", margin: "auto", marginBottom: 20 }}>
                            <Alert severity="success" onClose={() => this.setState({ success: null })}>
                                {success}
                            </Alert>
                        </Box>
                    )}

                    {/* Загрузка нового баннера */}
                    <Box style={{ width: "95%", margin: "auto", marginBottom: 20 }}>
                        <Paper style={{ padding: 20 }}>
                            <Typography variant="h6" style={{ marginBottom: 15 }}>
                                Загрузить новый баннер
                            </Typography>
                            <Dropzone onDrop={this.handleFileUpload} disabled={uploading}>
                                {({ getRootProps, getInputProps }) => (
                                    <div
                                        {...getRootProps()}
                                        style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '4px',
                                            padding: '20px',
                                            textAlign: 'center',
                                            cursor: uploading ? 'not-allowed' : 'pointer',
                                            backgroundColor: uploading ? '#f5f5f5' : '#fafafa',
                                            opacity: uploading ? 0.6 : 1,
                                        }}
                                    >
                                        <input {...getInputProps()} />
                                        {uploading ? (
                                            <p>Загрузка...</p>
                                        ) : (
                                            <p>Перетащите файл сюда или нажмите для выбора</p>
                                        )}
                                    </div>
                                )}
                            </Dropzone>
                        </Paper>
                    </Box>

                    {/* Список баннеров */}
                    <Box style={{ width: "95%", margin: "auto", marginBottom: 20 }}>
                        <Paper style={{ padding: 20 }}>
                            <Typography variant="h6" style={{ marginBottom: 15 }}>
                                Загруженные баннеры ({banners.length})
                            </Typography>
                            {loading ? (
                                <p>Загрузка...</p>
                            ) : banners.length === 0 ? (
                                <p>Баннеры не найдены</p>
                            ) : (
                                <Grid container spacing={2}>
                                    {banners.map((fileName: string, index: number) => (
                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                            <Paper
                                                style={{
                                                    padding: 10,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <img
                                                    src={this.getImageUrl(fileName)}
                                                    alt={this.extractFileName(fileName)}
                                                    style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        maxHeight: '200px',
                                                        marginBottom: 10,
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                    }}
                                                    onError={(e) => {
                                                        const target = e.target as HTMLImageElement;
                                                        // Предотвращаем бесконечный цикл - если уже пытались загрузить placeholder, не делаем ничего
                                                        if (target.src.includes('no-image.png') || target.dataset.failed === 'true') {
                                                            return;
                                                        }
                                                        console.error('Error loading image:', this.getImageUrl(fileName));
                                                        target.dataset.failed = 'true';
                                                        target.src = '/images/no-image.png';
                                                    }}
                                                    onLoad={(e) => {
                                                        const target = e.target as HTMLImageElement;
                                                        console.log('Image loaded successfully:', target.src);
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    style={{
                                                        marginBottom: 10,
                                                        wordBreak: 'break-word',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {this.extractFileName(fileName)}
                                                </Typography>
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="small"
                                                    onClick={() => this.handleDelete(fileName)}
                                                >
                                                    Удалить
                                                </Button>
                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>
                            )}
                        </Paper>
                    </Box>

                    <br />
                    <AnyQuestions />
                </main>
            </>
        );
    }
}
